import $ from 'jquery';
import Vars from '../../vars';
import Request from '../../components/request';
import Utils from '../../components/utils';
import Vk from './Social/Vk';

class Social {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $content : $()
    };

    _const = {
        entities : 'socials',
        entity   : 'social'
    };

    _args = {
        page : '',
        id   : 0
    };

    _state = {
        items : {},
        item  : {}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.page = args.page;
        self._args.title = args.title;
        self._args.id   = args.id || self._args.id;
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = $('.content');
    };

    _list = () => {
        let self = this;

        loader.decrease();

        self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
            crumbs : [
                {
                    title : 'Главная',
                    href  : '#'
                },
                {
                    title : 'Выгрузка в социальные сети'
                }
            ],
            dropdown : null,
            activate : null
        });

        self._elems.$content.html(Utils.renderProfileTemplate('socials', {
            breadcrumbs : self._state.breadcrumbs
        }));
    };

    _init = () => {
        let self = this;
        self._bindElements();
        if (!self._elems.$content.length) return;

        if (self._args.page === Vars.view.list) {
            self._list();
        }
        else if (self._args.page == Vars.page.social.vk) {
            new Vk({
                page : Vars.page.list
            });
        }
        else if (self._args.page == Vars.view.item) {
            new Vk({
                page : Vars.page.item,
                id   : self._args.id
            });
        }
    };
}

export default Social;